import React, { FC } from 'react';
import { Switch, Route } from 'react-router-dom';

// ROUTE
import { Router } from 'constant';

// COMPONENT
import { baseLoader } from 'components/Loading';
import SomethingWentWrongPage from 'components/SomethingWentWrongPage';

const IndividualLandingPage = baseLoader(() => import('page/CheckInCheckOut/IndividualLandingPage'));
const CenterBasedLandingPage = baseLoader(() => import('page/CheckInCheckOut/CheckInCheckOutCenterBasedLandingPage'));
const OrgLandingPage = baseLoader(() => import('page/CheckInCheckOut/OrgLandingPage'));
const SessionBasedLandingPage = baseLoader(
  () => import('page/CheckInCheckOutAac/CheckInCheckOutCenterBasedLandingPage')
);

const AppCheckInCheckOutRoute: FC = () => (
  <Switch>
    <Route exact component={SomethingWentWrongPage} path={Router.checkInCheckOutIndividualPageSomethingWrong} />
    <Route exact component={IndividualLandingPage} path={Router.checkInCheckOutIndividualWithActivityId} />
    <Route exact component={CenterBasedLandingPage} path={Router.checkInCheckOutCenterWithCenterId} />
    <Route exact component={OrgLandingPage} path={Router.orgCheckInCheckOutWithActivityId} />
    <Route exact component={SessionBasedLandingPage} path={Router.checkInCheckOutCenterWithSessionId} />
  </Switch>
);

export default AppCheckInCheckOutRoute;
